import { ChangeDetectorRef, EventEmitter, OnChanges, OnDestroy, OnInit, } from '@angular/core';
import { DurationFormat, DurationPipe } from '@freelancer/pipes';
import { TimeUtils } from '@freelancer/time-utils';
import { FontColor, FontType, FontWeight, TextSize } from '@freelancer/ui/text';
import { LocalizedDateFns } from '../localized-date-fns.service';
export var MINUTE = 60;
export var HOUR = MINUTE * 60;
export var DAY = HOUR * 24;
export var WEEK = DAY * 7;
export var MONTH = DAY * 30;
export var YEAR = DAY * 365;
var RelativeTimeComponent = /** @class */ (function () {
    function RelativeTimeComponent(dateFns, changeDetectorRef, timeUtils, durationPipe) {
        var _this = this;
        this.dateFns = dateFns;
        this.changeDetectorRef = changeDetectorRef;
        this.timeUtils = timeUtils;
        this.durationPipe = durationPipe;
        this.FontType = FontType;
        this.live = true;
        this.includeSeconds = true;
        this.suffix = true;
        this.strict = false;
        /** Display a secondary unit (eg. 1 hour, 1 minute). Can only display as if `strict` was on */
        this.secondaryUnit = false;
        this.color = FontColor.MID;
        this.size = TextSize.XXSMALL;
        this.weight = FontWeight.NORMAL;
        this.timePassed = new EventEmitter();
        this.showJustNowString = false;
        this.tick = function () {
            if (_this.timeoutId) {
                clearTimeout(_this.timeoutId);
            }
            var now = Date.now();
            _this.render(now);
            if (!_this.live) {
                return;
            }
            var then = _this._date.getTime();
            var seconds = Math.round((then - now) / 1000);
            if (!_this.hasTimePassed && seconds <= 0) {
                _this.hasTimePassed = true;
                _this.timePassed.emit();
            }
            // figure out how long to wait before recalculating
            // eg. if it says "4 hours" we know it won't be different in 1 minute, so we can wait longer.
            var period = Math.abs(seconds) < 2 * MINUTE
                ? 1000
                : seconds < 2 * HOUR
                    ? 1000 * 2 * MINUTE
                    : seconds < 2 * DAY
                        ? 1000 * HOUR
                        : 1000 * DAY;
            if (_this.secondaryUnit) {
                // if we show secondaryUnit, we want to check more often because we display more units
                period =
                    Math.abs(seconds) < HOUR + MINUTE
                        ? 1000
                        : seconds < DAY + HOUR
                            ? 1000 * MINUTE
                            : 1000 * HOUR;
            }
            _this.timeoutId = _this.timeUtils.setTimeout(function () {
                _this.tick();
            }, period);
        };
    }
    Object.defineProperty(RelativeTimeComponent.prototype, "date", {
        set: function (date) {
            this._date = new Date(date);
            this.hasTimePassed = false;
        },
        enumerable: true,
        configurable: true
    });
    RelativeTimeComponent.prototype.ngOnInit = function () {
        this.tick();
    };
    RelativeTimeComponent.prototype.ngOnChanges = function () {
        // Re-render and reset timer
        this.tick();
    };
    RelativeTimeComponent.prototype.ngOnDestroy = function () {
        clearTimeout(this.timeoutId);
    };
    RelativeTimeComponent.prototype.render = function (now) {
        // show "just now" as a string because date-fns doesn't support these two options together
        this.showJustNowString =
            this.strict &&
                !this.includeSeconds &&
                now - this._date.getTime() < MINUTE * 1000;
        if (this.showJustNowString) {
            return;
        }
        // otherwise use date-fns to format
        if (this.secondaryUnit) {
            var diff = Math.abs(now - this._date.getTime());
            this.relativeTime = this.durationPipe.transform(diff, DurationFormat.LONG);
        }
        else if (this.strict) {
            this.relativeTime = this.dateFns.formatDistanceStrict(this._date, new Date(), {
                includeSeconds: this.includeSeconds,
                addSuffix: this.suffix,
            });
        }
        else {
            this.relativeTime = this.dateFns.formatDistance(this._date, new Date(), {
                includeSeconds: this.includeSeconds,
                addSuffix: this.suffix,
            });
        }
        this.changeDetectorRef.markForCheck();
    };
    return RelativeTimeComponent;
}());
export { RelativeTimeComponent };
